// extracted by mini-css-extract-plugin
export default {"dashboard":"RadialProgressBar_dashboard__YK783","bg":"RadialProgressBar_bg__8fOKT","meter":"RadialProgressBar_meter__BlkPZ","proportion":"RadialProgressBar_proportion__IFEbr"};